// App.tsx
import React from 'react';
import { MotionConfig } from 'framer-motion';
import Home from './pages/Home';
import './styles/globals.css';

function App() {
  // reducedMotion="user" makes Framer Motion drop transform and layout
  // animations for visitors who ask the OS for reduced motion, while still
  // letting opacity fades through. The CSS media query in globals.css covers
  // the non-Framer animations.
  return (
    <MotionConfig reducedMotion="user">
      <Home />
    </MotionConfig>
  );
}

export default App;
